import { useDispatch, useSelector, useStore } from "react-redux";
import isAfter from "date-fns/isAfter";
import parseISO from "date-fns/parseISO";
import {
	getCurrentSeason as getCurrentSeasonAction,
	getSeasons as getSeasonsAction,
	initSeasonData as initSeasonDataAction,
	restoreDefaultGameConfiguration as restoreDefaultGameConfigurationAction,
	saveDefaultGameConfiguration as saveDefaultGameConfigurationAction,
	setCurrentSeasonById as setCurrentSeasonByIdAction,
	setRuleSetId as setRuleSetIdAction,
	setSeasonConfiguration as setSeasonConfigurationAction
} from "./actions";
import AppConfig from "../../config/app-config";

const useSeasonContext = () => {
	const dispatch = useDispatch();
	const store = useStore();

	const useSeasons = () => useSelector((state) => state.season.seasons);

	const useActiveSeasons = () =>
		useSelector((state) => {
			const today = new Date();
			return state.season.seasons.filter((s) =>
				isAfter(parseISO(s.endDate), today)
			);
		});

	const useCurrentSeason = () =>
		useSelector((state) => state.season.currentSeason);

	const useDefaultGameConfiguration = () =>
		useSelector((state) => state.season.defaultGameConfiguration);

	const useCustomFormData = () =>
		useSelector((state) => state.season.customFormData);

	const useIsLoading = () => useSelector((state) => state.season.isLoading);

	const useIsConfigurationLoading = () =>
		useSelector((state) => state.season.isConfigurationLoading);

	const state = {
		seasons: useSeasons,
		currentSeason: useCurrentSeason,
		defaultGameConfiguration: useDefaultGameConfiguration,
		customFormData: useCustomFormData,
		isLoading: useIsLoading,
		isConfigurationLoading: useIsConfigurationLoading,
		activeSeasons: useActiveSeasons
	};

	const setRuleSetId = (ruleSetId) => {
		const { currentSeason } = store.getState().season;
		setRuleSetIdAction(currentSeason, ruleSetId, dispatch);
	};

	const saveDefaultGameConfiguration = (config) => {
		const { currentSeason } = store.getState().season;

		saveDefaultGameConfigurationAction(currentSeason.id, config, dispatch);
	};

	const restoreDefaultGameConfiguration = () => {
		const { currentSeason } = store.getState().season;

		restoreDefaultGameConfigurationAction(currentSeason.id, dispatch);
	};

	const getSeasons = () => {
		const { selectedSport } = store.getState().app;
		if (selectedSport?.length) {
			getSeasonsAction(selectedSport, dispatch);
		}
	};

	const initSeasonData = (seasonId) => {
		initSeasonDataAction(
			seasonId,
			{ pageNumber: 0, pageSize: AppConfig.EVENTS.PAGINATION.PAGE_SIZE },
			dispatch
		);
	};

	const setCurrentSeasonById = (seasonId) => {
		setCurrentSeasonByIdAction(seasonId, dispatch);
	};

	const getCurrentSeason = () => {
		getCurrentSeasonAction(dispatch);
	};

	const refreshSeasonConfiguration = () => {
		const { currentSeason } = store.getState().season;
		setSeasonConfigurationAction(currentSeason?.id, dispatch);
	};

	return {
		state,
		getSeasons,
		saveDefaultGameConfiguration,
		restoreDefaultGameConfiguration,
		initSeasonData,
		setCurrentSeasonById,
		getCurrentSeason,
		setRuleSetId,
		refreshSeasonConfiguration
	};
};

export { useSeasonContext };
